import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import FilosofiaPage from "@/pages/FilosofiaPage";
import ProyectosPage from "@/pages/ProyectosPage";
import PublicidadPage from "@/pages/PublicidadPage";
import QueHacemosPage from "@/pages/QueHacemosPage";
import HablemosPage from "@/pages/HablemosPage";
import LegalPage from "@/pages/LegalPage";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          {/* Spanish routes (default) */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/filosofia" element={<FilosofiaPage />} />
            <Route path="/proyectos" element={<ProyectosPage />} />
            <Route path="/publicidad" element={<PublicidadPage />} />
            <Route path="/que-hacemos" element={<QueHacemosPage />} />
            <Route path="/hablemos" element={<HablemosPage />} />
            <Route path="/legal" element={<LegalPage />} />
          </Route>
          
          {/* English routes */}
          <Route element={<Layout />}>
            <Route path="/en" element={<HomePage />} />
            <Route path="/en/philosophy" element={<FilosofiaPage />} />
            <Route path="/en/projects" element={<ProyectosPage />} />
            <Route path="/en/advertising" element={<PublicidadPage />} />
            <Route path="/en/what-we-do" element={<QueHacemosPage />} />
            <Route path="/en/contact" element={<HablemosPage />} />
            <Route path="/en/legal" element={<LegalPage />} />
          </Route>
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
